import { render, staticRenderFns } from "./MaternityBase.vue?vue&type=template&id=46b7237a"
import script from "./MaternityBase.vue?vue&type=script&lang=js"
export * from "./MaternityBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports